import React from 'react';
import { TextField, InputAdornment, useMediaQuery } from '@mui/material';
import { SearchOutlined } from '@mui/icons-material';
import CustomTextField from '../../../../common/Form/TextField';
import { useTheme } from '@mui/material/styles';
import { variants } from '../../../../variants/variants';

const SearchBar = ({ searchText, setSearchText }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'));
  const getWidth = () => {
    if (isXs) return '90%';
    if (isSm) return '92%';
    if (isMd) return '95%';
    if (isLg) return '97%';
    if (isXl) return '97%';
    return '97%';
  };

  const getMargin = () => {
    if (isXs || isSm) return '0.5rem';
    return '1rem';
  };

  return (
    <CustomTextField
      onChange={e => setSearchText(e.target.value)}
      value={searchText}
      className={'Search'}
      size='small'
      placeholder='Search...'
      sx={{
        width: getWidth(),
        margin: getMargin(),
        marginTop: '1rem',
        marginBottom: isMobile ? 0 : '2rem',
        fontSize: variants.BODY,
        borderRadius: variants.boxRadius,
        borderBottom: 1,
        borderColor: 'divider',
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchOutlined />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
